<template>
	<div class="ingredient">
		<button type="button" class="btn" @click="openModal">
			성분 매핑하기 +
		</button>
		<RadioList
			:value="factorsDisplay"
			:radio-list="factorsDisplayList"
			class="ingredient__display-selector"
			@input="singleChange('factorsDisplay', $event)"
		/>
		<p v-html="getFactorInfo" class="ingredient__info" />
		<ul
			v-if="factorList && factorList.length"
			:style="setListHeight"
			class="ingredient__list"
		>
			<li
				v-for="item in factorList"
				:key="item.factorIdx"
				class="ingredient__list__item"
			>
				{{ item.factorName }}
			</li>
		</ul>
		<div v-else class="ingredient__no-list">
			등록된 매핑 정보가 없습니다
		</div>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import RadioList from '@/components/RadioList';

	export default {
		name: 'ProductIngredientList',
		components: {
			RadioList,
		},
		data() {
			return {
				maxListCnt: 11,
			};
		},
		computed: {
			...mapState('ProductController', [
				'isInquiry',
				'factorsDisplayList',
				'factorsDisplay',
				'factorList',
				'factorsInsertedDate',
				'factorsModifiedDate',
			]),
			getFactorInfo() {
				return `${(this.factorList || []).length} 건${this.isInquiry ? ` / <b>성분 등록일</b> : ${this.factorsInsertedDate} / <b>성분 수정일</b> : ${this.factorsModifiedDate}` : ''}`;
			},
			setListHeight() {
				const maxListCnt = this.maxListCnt - 1;
				return {
					maxHeight: `${maxListCnt * 29 + 28}px`,
				};
			},
		},
		methods: {
			singleChange(key, value) {
				this.$store.commit('ProductController/stateChange', [
					{ key, value },
				]);
			},
			openModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'ProductIngredientController',
					params: {
						selectedList: this.factorList.map(item => ({
							id: item.factorIdx,
							value: item.factorName,
						})),
						register: (value = []) => {
							this.$store.commit(
								'ProductController/stateChange',
								[{ key: 'factorList', value }]
							);
						},
					},
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.ingredient {
		width: 100%;
	}

	.ingredient__display-selector {
		margin: 0 0 0 18px;
		padding: 1px 0;
	}

	.ingredient__info {
		margin: 14px 0;
	}

	.ingredient__list {
		overflow: auto;
		height: auto;
		padding: 0 8px;
		border: solid 1px #dfe6ee;
	}

	.ingredient__list__item {
		padding: 8px 0;
		border-top: solid 1px #dfe6ee;

		&:first-child {
			border-top: none;
		}
	}

	.ingredient__no-list {
		border: solid 1px #dfe6ee;
		line-height: 150px;
		text-align: center;
	}
</style>
